'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$Admin(user) {
  this.Lapp_data_OperationalAppRegisteredUser$Admin__f_user = null;
  this.Lapp_data_OperationalAppRegisteredUser$Admin__f_user = user;
}
export { $c_Lapp_data_OperationalAppRegisteredUser$Admin as $c_Lapp_data_OperationalAppRegisteredUser$Admin };
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$Admin;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$Admin() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$Admin as $h_Lapp_data_OperationalAppRegisteredUser$Admin };
$h_Lapp_data_OperationalAppRegisteredUser$Admin.prototype = $c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1850585712), true);
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OperationalAppRegisteredUser$Admin)) {
    var x = this.Lapp_data_OperationalAppRegisteredUser$Admin__f_user;
    var x$2 = x$0.Lapp_data_OperationalAppRegisteredUser$Admin__f_user;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.productPrefix__T = (function() {
  return "Admin";
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_OperationalAppRegisteredUser$Admin__f_user;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "user";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Admin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_OperationalAppRegisteredUser$Admin)));
}
export { $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Admin as $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Admin };
var $d_Lapp_data_OperationalAppRegisteredUser$Admin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$Admin, "app.data.OperationalAppRegisteredUser$Admin", ({
  Lapp_data_OperationalAppRegisteredUser$Admin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$Admin as $d_Lapp_data_OperationalAppRegisteredUser$Admin };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-Admin.js.map
